import AxiosInstance from "./api";

export const FixedAssetsDepreciationService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/depreciation-allocation", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get("/private/depreciation-allocation/" + id);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/depreciation-allocation", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/depreciation-allocation/" + id, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete("/private/depreciation-allocation/" + id);
  },
};
